// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_3JkT94g8pOuGNa-Rr4d8rQ=="};